export var cardBodyStyles = {
  root: function root(_ref) {
    var v = _ref.variables,
        p = _ref.props;
    return Object.assign({
      display: 'flex',
      flexDirection: 'column',
      margin: v.bodyMargin
    }, p.fitted && {
      margin: v.fittedBodyMargin
    });
  }
};
//# sourceMappingURL=cardBodyStyles.js.map
